<div class="row" *ngIf="service">
    <div class="col-12 p-4">
      <strong>
        {{'List of GDBs used in the service' | translate}}
      </strong>
      <div class="form-group" style="margin-bottom: 0">
      <primary-text-button (click)="refreshExternalServices()">
        {{'Refresh external services' | translate}}
      </primary-text-button></div>
    </div>
</div>